"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "tortora": {
    "dc586636": [{
      "hkey": "01b0912b",
      "slug": "tortora",
      "name": "Tortora",
      "primary": true,
      "skipSearch": false
    }],
    "acqualisparti": [{
      "hkey": "01b0912b",
      "slug": "tortora",
      "name": "Tortora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "402df6c6": [{
      "hkey": "01b0912b",
      "slug": "tortora",
      "name": "Tortora",
      "primary": true,
      "skipSearch": false
    }],
    "carro": [{
      "hkey": "01b0912b",
      "slug": "tortora",
      "name": "Tortora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c09b486e": [{
      "hkey": "60da335b",
      "slug": "tortora",
      "name": "Tortora",
      "primary": true,
      "skipSearch": false
    }],
    "centro-storico": [{
      "hkey": "60da335b",
      "slug": "tortora",
      "name": "Tortora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6f56f2a7": [{
      "hkey": "01b0912b",
      "slug": "tortora",
      "name": "Tortora",
      "primary": true,
      "skipSearch": false
    }],
    "maricosa": [{
      "hkey": "01b0912b",
      "slug": "tortora",
      "name": "Tortora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0d90c384": [{
      "hkey": "01b0912b",
      "slug": "tortora",
      "name": "Tortora",
      "primary": true,
      "skipSearch": false
    }],
    "massacornuta": [{
      "hkey": "01b0912b",
      "slug": "tortora",
      "name": "Tortora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8dd37b80": [{
      "hkey": "01b0912b",
      "slug": "tortora",
      "name": "Tortora",
      "primary": true,
      "skipSearch": false
    }],
    "melara": [{
      "hkey": "01b0912b",
      "slug": "tortora",
      "name": "Tortora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "eef72849": [{
      "hkey": "01b0912b",
      "slug": "tortora",
      "name": "Tortora",
      "primary": true,
      "skipSearch": false
    }],
    "pizinno": [{
      "hkey": "01b0912b",
      "slug": "tortora",
      "name": "Tortora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7bdc5dc0": [{
      "hkey": "01b0912b",
      "slug": "tortora",
      "name": "Tortora",
      "primary": true,
      "skipSearch": false
    }],
    "san-nicola": [{
      "hkey": "01b0912b",
      "slug": "tortora",
      "name": "Tortora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "09128676": [{
      "hkey": "01b0912b",
      "slug": "tortora",
      "name": "Tortora",
      "primary": true,
      "skipSearch": false
    }],
    "san-pietro": [{
      "hkey": "01b0912b",
      "slug": "tortora",
      "name": "Tortora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "842d7ec3": [{
      "hkey": "01b0912b",
      "slug": "tortora",
      "name": "Tortora",
      "primary": true,
      "skipSearch": false
    }],
    "san-sago": [{
      "hkey": "01b0912b",
      "slug": "tortora",
      "name": "Tortora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4d0ab996": [{
      "hkey": "01b0912b",
      "slug": "tortora",
      "name": "Tortora",
      "primary": true,
      "skipSearch": false
    }],
    "sant-elia": [{
      "hkey": "01b0912b",
      "slug": "tortora",
      "name": "Tortora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f1fd16f5": [{
      "hkey": "01b0912b",
      "slug": "tortora",
      "name": "Tortora",
      "primary": true,
      "skipSearch": false
    }],
    "santi-quaranta": [{
      "hkey": "01b0912b",
      "slug": "tortora",
      "name": "Tortora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e1e60c3d": [{
      "hkey": "01b0912b",
      "slug": "tortora",
      "name": "Tortora",
      "primary": true,
      "skipSearch": false
    }],
    "sarre": [{
      "hkey": "01b0912b",
      "slug": "tortora",
      "name": "Tortora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1a3e227d": [{
      "hkey": "01b0912b",
      "slug": "tortora",
      "name": "Tortora",
      "primary": true,
      "skipSearch": false
    }],
    "valle-dei-pali": [{
      "hkey": "01b0912b",
      "slug": "tortora",
      "name": "Tortora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a20c9866": [{
      "hkey": "01b0912b",
      "slug": "tortora",
      "name": "Tortora",
      "primary": true,
      "skipSearch": false
    }],
    "valle-del-grillo": [{
      "hkey": "01b0912b",
      "slug": "tortora",
      "name": "Tortora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;